/**
 * Checks existence of SCMP API and updates consent
 */
export const updateTcfApi = (consentString) => {
    var _a, _b, _c;
    if (!(consentString &&
        typeof ((_a = window === null || window === void 0 ? void 0 : window.scmp) === null || _a === void 0 ? void 0 : _a.initCmpApi) === 'function' &&
        typeof ((_b = window === null || window === void 0 ? void 0 : window.scmp) === null || _b === void 0 ? void 0 : _b.getTcStringFromCmpApi) === 'function' &&
        typeof ((_c = window === null || window === void 0 ? void 0 : window.scmp) === null || _c === void 0 ? void 0 : _c.updateCmpApi) === 'function')) {
        // scmp tcf api is not usable
        return;
    }
    const tcf = window.scmp.getTcStringFromCmpApi();
    if (tcf === null) {
        // scmp tcf api is not initialized
        window.scmp.initCmpApi();
        window.scmp.updateCmpApi(consentString);
    }
    if (tcf === '') {
        // scmp tcf api does not have consentString
        window.scmp.updateCmpApi(consentString);
    }
};
